import { Component } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { StringConstants } from 'src/app/constants/string-constants';

@Component({
    selector: 'app-profile',
    templateUrl: './profile.component.html',
    styleUrls: ['./profile.component.scss'],
    standalone: false
})
export class ProfileComponent {
  public profile$: Observable<any>;

  constructor(private http: HttpClient) {
    this.profile$ = this.http.get('https://graph.microsoft.com/v1.0/me');
  }
}
